import React, { Component } from 'react'
import NewMessage from './newMessage';
import ReadMessage from './readMessage';
import { notificationColorConfig } from '../../../JS/colorConfig';
import { connect } from 'react-redux';
import { guestJourneyNotification, sendAnalytics } from '../../../../action/homeAction';
import { CLICKED, EXIT, months } from '../../../../config/constant';
import clientConfigApi from '../../../../config/config';
import { Link } from "react-router-dom";
import { CMSPath } from '../../../../config/constant';
import { scrollToTop } from '../../../../JS/scrollToTop'
import moment from 'moment';
import PropTypes from 'prop-types';
import { inAppBrowser } from '../../../JS/inAppBrowser';
import { setDeviceConfigFailed, setChatBubble } from '../../../../action/action';
import {withTranslation} from "react-i18next";
import {scrollUpListenerForConditionalRendering} from '../../roomControl2/scrollEffect'
import { calculateTimeDifference, getDefaultAnalyticsLabel } from '../../../JS/utility';

class Notifications extends Component {

    constructor(props){
        super(props);
        this.room = localStorage.getItem("room");
        this.state = {
            showScrollToTopVar: false,
            widgetLaunchTime: new Date
        }
    }

    dateFormatHandler = (date) => {

        if (!date){
            return;
        }

        const dat = moment(date);
        return dat.format("MMM DD");
    }

    openFAQPage = () => {
        
        inAppBrowser(this.props.faqUrl,this.props, false, {displayName: "FAQ", dontSetCurrentWidget: true})
        
    }

    /*newStatusHandler = (token) => {

        const arr = this.props.notifications.map(el => el.id);
  
        
        try {
            clientConfigApi.put(
              "/textMessage/ack",
              {
                "header": {
                  "sessionToken": token
                },
                "payload":{
                  "messages": [
                      {
                        "messageIds": arr,
                        "status": "NEW"
                      }
                  ]   
                }
                
              }
            ).then((res) => {
              console.log("notifications acknowledgement", res);
            })
              .catch(
                ({ response = {} }) => {
                  console.log("Notification Api failed with the status code:", response.status);
                }
              )
          } catch (e) {
            console.log(`error in api call to path= "/textMessage/ack"`, e);
          }
    }*/

    showScrollToTop = (status) => {
        if(status){
            this.setState({showScrollToTopVar : true})
        } else {
            this.setState({showScrollToTopVar : false})
        }
    }

    getNewNotCount = (notifications) => {
        if(!notifications || notifications == "null"){
            return 0;
        }

        let count = 0;

        for(let obj of notifications){
            if(obj.status === "NEW"){
                count = count + 1;
            }
        }

        return count;
    }

    componentWillUnmount() {
        // Send Analytics
        let widgetCloseTime = new Date
        let duration = calculateTimeDifference(this.state.widgetLaunchTime, widgetCloseTime, 'second')
        let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
        // this.props.sendAnalytics(
        //     this.props.guestDetail, 
        //     "Notifications", 
        //     EXIT, 
        //     {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "duration": duration}, 
        //     0, 
        //     this.props.guestIsLoggedIn
        // );
        // 
    }


    componentDidUpdate(){
        notificationColorConfig(this.props.menuColor);
    }

    componentDidMount(){
        scrollToTop();
        const sessionToken = localStorage.getItem('GuestJourneySessionToken');
        this.props.guestJourneyNotification(sessionToken);
        notificationColorConfig(this.props.menuColor);
        
        if(window.FirebasePlugin){
            window.FirebasePlugin.setScreenName("notifications");
        }
        if(this.props.showChatBubble){
            this.props.setChatBubble(false)
        }

        scrollUpListenerForConditionalRendering(this.showScrollToTop, 500)

            // Send Analytics
            let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
            // this.props.sendAnalytics(
            //     this.props.guestDetail, 
            //     "Notifications", 
            //     CLICKED, 
            //     {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget"}, 
            //     0, 
            //     this.props.guestIsLoggedIn
            // );
            // 
    }

    render() {
        const { t } = this.props
        return (

            <section id="notifications" class="widgets">

                <div class="image-heading">
                    <div class="img-banner">
                        <img src={`${CMSPath}${this.props.bgImage}`} />
                    </div>

                    <div class="heading" id="heading">
                        <h1>{this.props.PageNameFromParent ? this.props.PageNameFromParent :
                            this.props.selectedHomePage && this.props.selectedHomePage.tabName ?
                                this.props.selectedHomePage.tabName : ""}
                        </h1>
                        {this.getNewNotCount(this.props.notifications) > 0 ? <p className='unread-notification-text'>You have {this.getNewNotCount(this.props.notifications)} new messages</p>
                        :this.props.notifications && this.props.notifications.length > 0 && <p>You have {this.props.notifications.length} messages</p>}
                    </div>
                </div>

                <div class="widgets user-info seperator">
                    <div class="controls">
                        {/* <Link exact to = "/notifications/writeMsg" class="button bold tile-container margin-bottom-1">Write New Message</Link> */}
                        {this.props.faqUrl && <a onClick = {this.openFAQPage} class="button secondary bold tile-container">{this.props.t('notifications.faq')}</a>}
                    </div>
                </div>
                
              {this.props.notifications.length > 0 ?
                
                <div class="widgets msg-section">
                    
                    {this.props.notifications.map(obj => {
                        
                            return(
                                <Link exact to ={`/notifications/readMsg?id=${obj.id}`} class={`tile-selection tile-container thumbnails ${obj.status === "NEW" ? "unread" : obj.status === "READ" ? "" : "" }`} key = {obj.id} 
                                >
                                    {/*<div class="thumb-img">
                                        <i class="fas fa-lg fa-circle"></i>
                                    </div>*/}
                                    <div class="thumb-date">
                                        {this.dateFormatHandler(obj.dateCreated)}
                                    </div>
                                    <div class="tile-selection-text">
                                        <div class="tile-selection-heading">{obj.sender}</div>
                                        <div class="tile-selection-desc">{obj.messageText}</div>
                                    </div>
                                </Link>
                            )
                    })}
                </div>

                : <div class="widgets msg-section align-center">
                   <svg xmlns="http://www.w3.org/2000/svg" width="81" height="80" viewBox="0 0 81 80" fill="none">
  <path d="M73.8337 40H53.8337L47.167 50H33.8337L27.167 40H7.16699M73.8337 40V60C73.8337 61.7681 73.1313 63.4638 71.881 64.714C70.6308 65.9643 68.9351 66.6667 67.167 66.6667H13.8337C12.0655 66.6667 10.3699 65.9643 9.11961 64.714C7.86937 63.4638 7.16699 61.7681 7.16699 60V40M73.8337 40L62.3337 17.0333C61.7817 15.9226 60.9309 14.9879 59.8768 14.3343C58.8228 13.6806 57.6073 13.334 56.367 13.3333H24.6337C23.3934 13.334 22.1779 13.6806 21.1238 14.3343C20.0697 14.9879 19.2189 15.9226 18.667 17.0333L7.16699 40" stroke="#231F20" stroke-opacity="0.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                    <p class="heading" style={{color: "#000"}}>No messages yet</p>
                    {/* <p>You will be notified as soon as one comes in or you can initiate a conversation with our staff</p> */}
			    </div>}

                {this.room && this.room !== "null" && this.props.notifications && this.props.notifications.length > 10 && this.state.showScrollToTopVar && <div class="doorkey" onClick={scrollToTop}>
                    <a class="tile-container" 
                    style = {{
                        background: this.props.menuColor.assetBackgroundSelectorColor,
                        width:"3rem",
                        height:"3rem"
                    }}>
                        <i class="fas fa-chevron-up" style={{fontSize:"90%"}}></i>
                    </a>
                </div>}


            </section>
        )
    }
}

Notifications.propTypes = {
    PageNameFromParent: PropTypes.string,
    GreetingFromParent: PropTypes.string
}

Notifications.defaultProps = {
    PageNameFromParent: "",
    GreetingFromParent: ""
}

const mapStateToProps = state => {
    return {
      menuColor: state.store.home.MenuColor,
        faqUrl: state.store.home.faqUrl,
        bgImage: state.store.home.currentDuration.launcherBgImageUrl,
        selectedHomePage: state.store2.currentHomePage,
        notifications: state.store.home.gJnotifications,
        showChatBubble: state.store.showChatBubble,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
    }
  }

export default connect(mapStateToProps,{ 
    guestJourneyNotification,
    setDeviceConfigFailed,
    setChatBubble,
    sendAnalytics
})(withTranslation('translations')(Notifications))
